import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const OaCosts = React.lazy(() => import('./index'));
const OaCostTable = React.lazy(() => import('./oaCostTable'));
const OaCost = React.lazy(() => import('./oaCost'));
const OaCostDetail = React.lazy(() => import('./oaCostDetail'));
const AddNewOaCost = React.lazy(() => import('./addNewOaCost'));
const EditOaCost = React.lazy(() => import('./editOaCost'));

export const useOaCostRoutes = () => {

    return (
        <React.Fragment>
            <Route path="oacost" element={<Suspense fallback={<div>منتظر باشید...</div>}><OaCosts /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><OaCostTable /></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewOaCost /></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><OaCost /></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><OaCostDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditOaCost /></Suspense> } />
                </Route>
            </Route>
        </React.Fragment>
    )
}